// extracted by mini-css-extract-plugin
module.exports = {"footer":"eb_G2GR","footerLink":"GQYOKOA"};